import { Text, View } from "../Base";

import KeyValue from "../Sections/KeyValue";
import React from "react";
import { formatMinutesToHHMM } from "../../utils/date";
import { makeStyles } from "@mui/styles";
import { padZeros } from "../../utils/routes";
import { palette } from "../../theme/palette";
import { selectedOverlaySelector } from "../../reducers/matrixProfile/selectors";
import { useSelector } from "react-redux";

const useStyles = makeStyles(({ typography }) => ({
  list: {
    overflow: "auto",
    marginRight: "-14px",
  },
  item: {
    marginTop: typography.pxToRem(2),
  },
  section: {
    marginTop: typography.pxToRem(2),
    display: "flex",
    flexDirection: "row",
    background: palette.typography.white.neutral,
    padding: "0.625rem",
    paddingBottom: "0.5rem",
    cursor: "default",
    color: "white",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    marginTop: "5px",
  },
  right: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginLeft: "5px",
  },
  contentLeft: {
    display: "flex",
    flex: "1 0 50%",
    flexDirection: "column",
  },
  contentRight: {
    flex: "1 0 50%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    height: "1.25rem",
    fontSize: "18px",
    lineHeight: "24px",
    textTransform: "uppercase",
  },
  subheader: {
    lineHeight: "20px",
    fontSize: "14px",
  },
  smName: {
    marginTop: "7px",
  },
}));

const WaveItem = ({ wave }) => {
  const styles = useStyles();
  const selectedOverlay = useSelector(selectedOverlaySelector);

  return (
    <View className={styles.section}>
      <View className={styles.right}>
        <Text className={styles.header} data-testid="section-name">
          Wave {wave.waveName}
        </Text>

        <View className={styles.content}>
          <View className={styles.contentLeft}>
            <KeyValue
              leftSize={9}
              rightSize={10}
              property={"Routes"}
              value={`${padZeros(wave.totalRoutes, 3)}(${
                wave.totalRoutesPercentage
              }%)`}
            />
            {selectedOverlay && (
              <View>
                <KeyValue
                  leftSize={9}
                  rightSize={10}
                  property={"Stops"}
                  value={`${padZeros(wave.totalStops, 3)}(${
                    wave.totalStopsPercentage
                  }%)`}
                />
                <KeyValue
                  leftSize={9}
                  rightSize={10}
                  property={"Parcels"}
                  value={`${padZeros(wave.totalParcels, 3)}(${
                    wave.totalParcelsPercentage
                  }%)`}
                />
                <KeyValue
                  leftSize={9}
                  rightSize={10}
                  property={"Collections"}
                  value={`${padZeros(wave.totalCollections, 3)}(${
                    wave.totalCollectionsPercentage
                  }%)`}
                />
              </View>
            )}
          </View>
          <View className={styles.contentRight}>
            {selectedOverlay && (
              <View>
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Exceptions"}
                  value={`${padZeros(wave.routesWithExceptions, 3)}(${padZeros(
                    wave.totalExceptions,
                    3
                  )})`}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"SPR"}
                  value={padZeros(wave.totalSPR, 3)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Duty"}
                  value={formatMinutesToHHMM(wave.totalAverageDutyTime)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"OT"}
                  value={formatMinutesToHHMM(
                    wave.totalAverageOpportunityMinutes
                  )}
                />
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default WaveItem;
